// extracted by mini-css-extract-plugin
export default {"body":"ReportRelatedUpdates_body__iw-qm"};